import React from 'react';

import { getSentryGlobalScope, type SentryTags } from '@gitbook/util-debug';

/**
 * Set a tag on the Sentry scope.
 */
export function useSetSentryTag(tagName: SentryTags, tagValue: string | null) {
    React.useEffect(() => {
        const scope = getSentryGlobalScope();
        if (tagValue) {
            scope.setTag(tagName, tagValue);
        }
    }, [tagName, tagValue]);
}
